import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--checkbox"
//
// Applies the native `indeterminate` property to the checkbox. Indeterminate
// is not expressible via an HTML attribute, so it must be set in JS — this
// mirrors the tri-state behaviour of the @a-safe-digital React Checkbox.
export default class extends Controller {
  static values = { indeterminate: { type: Boolean, default: false } }

  connect() {
    this.apply()
  }

  indeterminateValueChanged() {
    this.apply()
  }

  apply() {
    const input = this.element.querySelector('input[type="checkbox"]')
    if (input) input.indeterminate = this.indeterminateValue
  }
}
